import React, { useEffect, useState, useMemo } from "react";
import { BreadCrumbSecttion } from "../component/BreadCrumbSecttion";
import Footer from "../component/Footer";
import { Col, Container, Row } from "react-bootstrap";
import SelectDropDown from "../component/SelectDropDown";
import InputField from "../component/InputField";
import PrimaryGradientButton from "../component/PrimaryGradientButton";
import Header from "../component/Header";
import RegistrationService from "../services/registration";
import UploadFile from "../component/UploadFile";
// import OTPBox from "../component/OTPBoxEnrollMember";
import OTPBox from "../component/OTPBox";
import ProfileService from "../services/Profile";
import AlertMsg from "../component/AlertMsg";
import { useNavigate } from "react-router-dom";
import BasicProfileComponent from "../component/BasicProfileComponent";
import toast from "react-hot-toast";
import { useDispatch, useSelector } from "react-redux";
import { addRegistrationHierarchies } from "../redux/slices/registrationHierarchiesSlice";
import { addLocationData } from "../redux/slices/locationDataSlice";
import { addBasicProfileDetails } from "../redux/slices/currentUserSlice";
import { validateDoc, validatepincode } from "../constants/commonFunction";
import { mobileHandler } from "../constants/commonFunction";
import PurchaseService from "../services/Purchase";
import SimpleModal from '../component/SimpleModal'
import DocumentImage from '../component/DocumentImage'
import Form from "react-bootstrap/Form";
// import { DatePicker } from "antd";
import DatePicker from "../component/DatePicker";

import dayjs from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
dayjs.extend(customParseFormat);
const dateFormat = 'YYYY-MM-DD';

const EnrollMember = (route, navigation) => {
	const dispatch = useDispatch();
	const currentBrand = useSelector(state => state.userTypeSlice.currentBrand)
	const basicProfileDetails = useSelector(state => state.currentUser.basicProfileDetails)
	const registrationHierarchiesDetails = useSelector(state => state.registrationHierarchies.hierarchiesDetails)
	const locationData = useSelector(state => state.locationData)
	const from = route.params?.from;
  	const payloadTemp = route.params?.payloadTemp;
	// ##############################################################################################
	// ##############################################################################################

	const [documentType, setdocumentType] = useState([]);
	const [selectedKYC, setSelectedKYC] = useState({id: "", title: ""});
	const [isOTPBlock, setIsOTPBlock] = useState(false);
	const [panImage, setPanImage] = useState(null);
	const [frontImage, setFrontImage] = useState(null);
	const [userInfo, setUserInfo] = useState(null);
	const [backImage, setBackImage] = useState(null);
	const [profileImage, setProfileImage] = useState(null);
	const [nameValidationError, setNameValidationError] = useState("");
	const [personaValidationError, setPersonaValidationError] = useState("");
	const [brandValidationError, setBrandValidationError] = useState("");
	const [kycValidationError, setKycValidationError] = useState("");
	const [kycUplodBlock, setKycUploadBlock] = useState(false);
	const [kycDetailsValidationError, setKycDetailsValidationError] = useState("");
	const [regFormBlock, setRegFormBlock] = useState(true);
	const [persona, setPersona] = useState([]);
	const [isbrand, setIsBrand] = useState([]);
	const [language, setLanguage] = useState([]);
	const [isLoginSuccess, setIsLoginSuccess] = useState({
		isLogin: true,
		heading: "",
		text: "",
	});
	const [showAlert, setShowAlert] = useState(false);
	const [mobileNoVerified, setMobileNoVerified] = useState(false)
	//First Name Validate
	const [isFullNameValid, setIsFullNameValid] = useState(true);
	// Mobile number validation function
	const [mobileValidationError, setMobileValidationError] = useState("");
	const [selectedPersona, setSelectedPersona] = useState({ id: "", title: "" });
	const [selectedBrand, setSelectedBrand] = useState(currentBrand);

	// added in march 13
	const [emailValidationError, setEmailValidationError] = useState("");
	const [fileNotUploadedAlert, setfileNotUploadedAlert] = useState('');
	const [fileNotUploadedFrontAlert, setfileNotUploadedFrontAlert] = useState('');
	const [fileNotUploadedBackAlert, setfileNotUploadedBackAlert] = useState('');
	const [profilePicNotUploadedAlert, setProfilePicNotNotUploadedAlert] = useState('');
	const [checkBoxValidationAlert, setCheckBoxValidationAlert] = useState('');
	const [agreedCheckBoxValidationAlert, setAgreedCheckBoxValidationAlert] = useState('');
	const [isChecked, setIsChecked] = useState();
	const [isAgreedChecked, setIsAgreedChecked] = useState();
	const navigate = useNavigate();

	const [user, setUser] = useState({
		nameKYC: "",
		mobile: "",
		selectKYC: "",
		kycDetails: "",
		email: "",
		refeferalCode: ""
	});
	const [isButtonLoading, setIsButtonLoading] = useState(false);
	const [hierType, setHiertype] = useState({id: '', title: ''});
	const [mobile, setMobile] = useState('');
	const [brand, setBrand] = useState({id: '', title: ''});
	const [userBrand, setUserBrand] = useState('');
	const [regex, setRegex] = useState(''); 
	const [mobileRes, setMobileRes] = useState({});
	const [isInputFieldEditable, setIsInputFieldEditable] = useState(true);
	const [isNameReadOnly, setIsNameReadOnly] = useState(false);
	const [brandType, setBrandType] = useState([]);
	const [existInSameBrand, setExistInSameBrand] = useState(false);
	const [questionModalOpen, setQuestionModalOpen] = useState(false);
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [name, setName] = useState({});
	const [kycType, setKycType] = useState({});
	const [fullName, setFullName] = useState({});
	const [kycDet, setKycDet] = useState({});
	const [selectUserKYC, setSelectedUserKYC] = useState({
		profilePic: '',
		panNo: '',
		panImage: '',
		aadharNo: '',
		aadharImageFront: '',
		aadharImageBack: '',
		voterId: '',
		voterImageFront: '',
		voterImageBack: '',
		DLNo: '',
		DLImageFront: '',
		DLImageBack: '',
	  });
	const [userExists, setUserExists] = useState(false);
	const [pendingKYC, setPendingKYC] = useState(false);
	const [maritalStatus, setMaritalStatus] = useState({ id: "", title: "" });
	const [allDistrict, setAllDistrict] = useState([]);
	const [state, setState] = useState({ id: "", title: "" });
	const [city, setCity] = useState({ id: "", title: "" });
	const [district, setDistrict] = useState({ id: "", title: "" });
	const [country, setCountry] = useState({ id: "", title: "" });
	const [address2, setAddress2] = useState('');
	const [address3, setAddress3] = useState('');
	const [pincode, setPincode] = useState('');
	const [selectedTaluka, setSelectedTaluka] = useState({ id: "", title: "" });
	const [selectedBranch, setSelectedBranch] = useState({ id: "", title: "" });
	const [selectedTso, setSelectedTso] = useState({ id: "", title: "" });
	const [spouseName, setspouseName] = useState('');
	const [maritalStatusNew, setmaritalStatusNew] = useState({ id: "", title: "" });
	const [selectedOfficer, setSelectedOfficer] = useState({ id: "", title: "" });
	const [selectedOffMember, setSelectedOffMember] = useState({ id: "", title: "" });
	const [allTaluka, setAllTaluka] = useState([]);
	const [infoLoading, setInfoLoading] = useState(true);
	const [date_of_birth, setdate_of_birth] = useState('');
	const [date_of_anniversary, setdate_of_anniversary] = useState('');
	const [hierDesc, setHierDesc] = useState('');
	const [fetchKYCInfoResponse, setFetchKYCInfoResponse] = useState(null);
	const [disabledBlock, setDisabledBlock] = useState(true);

	  const documentTypeOptions = useMemo(() => [
		{
		  title: 'Voter ID',
		  id: 'voterId',
		  fetchDocId: 6
		},
		{
		  title: 'Driving License',
		  id: 'driving_license',
		  fetchDocId: 7
		},
		{
		  title: 'PAN',
		  id: 'pan',
		  fetchDocId: 2
		},
	  ], []);

	useEffect(() => {
		setUserInfo(JSON.parse(localStorage.getItem('userInfo')));
		const fetchData = async () => {

			try {
				const kycTypeResponse = await RegistrationService.kycType();
				const kycList = kycTypeResponse.response.KYCTypes;
				
				setdocumentType(kycList);
				// Fetch Hierarchies
				let allHierarchies = registrationHierarchiesDetails;
				if (!allHierarchies || allHierarchies.length === 0) {
					const hierarchiesResponse = await RegistrationService.getHierarchies();
					allHierarchies = hierarchiesResponse.response.hierarchiesDetails;
					dispatch(addRegistrationHierarchies({ hierarchiesDetails: allHierarchies }));
				}
				const contractorOnly = allHierarchies
            		.filter(item => item.name === "CONTRACTOR")
            		.map(item => ({
              			id: item.id,
              			title: item.name
            	}));

				// const hierarchies = hierarchiesResponse.response.hierarchiesDetails.map(
				// 	(item) => ({
				// 		id: item.id,
				// 		title: item.name,
				// 	})
				// );
				// setPersona(hierarchies);
				setPersona(contractorOnly);

				// Fetch Brands
				const brandResponse = await ProfileService.getBrand();
				const brands = brandResponse.response.message.map((item) => ({
					id: item.brandId,
					title: item.brandName,
				}));
				setIsBrand(brands);
				// const currentBrand = localStorage.getItem('currentBrand');
				// setSelectedBrand(currentBrand == '1'? ({
				// 	id: 1,
				// 	title: 'ACC Limited'
				// }): ({id: 2, title: 'Ambuja Cement Ltd.'}));
				// Fetch KYC Types
			} catch (error) {
			}
		};

		fetchData();
	}, []);
	  
const getPhoneDetails = async () => {
	setLoading(true);
	const brandId = (JSON.parse(localStorage.getItem('currentBrand'))).id;
	const payload = {
		userType: selectedPersona.title.toLowerCase(),
		brand_id: parseInt(brandId),
		phone: mobile,
	};
  
	try {	  
	  const res = await ProfileService.getKYCDetails(payload);
	  setLoading(false);  
	  if (res.response.contactExist === 'TRUE' && res.response.existOnSameBrand === 'TRUE') {
		setExistInSameBrand(true);
		setQuestionModalOpen(true);
		setDescription("This mobile is already associated with the current brand.")
	  }
	  else if (res.response.contactExist === 'TRUE' && res.response.existOnSameBrand === 'FALSE') {
		// new page needed
		setIsModalOpen(true);
		setMobileRes(res.response.contactDetails);
		setDescription(`This mobile number is already associated with a brand. Do you want to continue enrollment with ${currentBrand.title} ?`)
		setKycType(res.response.kycDetails);
		setUserExists(true);
		
	  }
	  else{
		// ekyc needed
		setUserExists(false);
		setQuestionModalOpen(false);
		setIsModalOpen(false);
	  }
	} catch (err) {
	  console.error('Error fetching phone details:');
	  setLoading(false);
	}
  };

  function onResponse(res) {
	if (res == 'yes') {
	} else {
	  setMobile('');
	  setHiertype({id: '', title: ''});
	}
  }

  function checkForRegex(n = '') {
    try {
      if (n !== '') {
        // Use a safe regex pattern for mobile validation instead of dynamic RegExp
        const mobileRegex = /^[6-9]\d{9}$/;
        return mobileRegex.test(mobile);
      } else {
        if (!!regex) {
          // Use a safe regex pattern for mobile validation instead of dynamic RegExp
          const mobileRegex = /^[6-9]\d{9}$/;
          return mobileRegex.test(mobile);
        }
      }
    } catch (error) {
      console.error('Regex validation error:');
      return false;
    }
  }

  useEffect(() => {
	if (checkForRegex(/^[6-9]\d{9}$/, mobile)&& selectedPersona ) {
	  getPhoneDetails();
	  setIsInputFieldEditable(false);
	}
	setMobileRes({});
  }, [mobile, selectedPersona]);

  function resetFields(){
	setMobileRes('');
	setHiertype({id: '', title: ''});
	setBrand({id: '', title: ''});
  }

//   function ValidatePhoneNumber(num) {
//     let contactPetrn = new RegExp(/^(\+\d{1,3}[- ]?)?\d{10}$/);
//     let numS = num + '';
//     if (contactPetrn.test(num) && parseInt(numS.charAt(0)) > 5) {
//       return true;
//     }
//     return false;
//   }

  const getBrand = async () => {
	try {
	  const token = localStorage.getItem('access_token');
	  const res = await PurchaseService.getBrandForPurchase(token);
	  if (res.success) {

  
		const allBrands = res.response.brandDetails.map(item => ({
		  id: String(item.id),
		  title: item.name,
		  image: { uri: item.brand_logo },
		}));

		setBrandType(allBrands);
  
		if (allBrands.length > 0) {
		  setBrand(allBrands[0]);
		}
	  } else {
		setBrandType([]);
	  }
	} catch (err) {
	  console.error('Error fetching brand details:');
	}
  };

  
	  

	//Functions
	const checkKycDetailsValid = () => {
		if (
			user.kycDetails == "" ||
			user.selectKYC == "" ||
			kycDetailsValidationError !== ""
		) {
			return true;
		}
	};

	const handleCheckboxChange = (e) => {
		setIsChecked(e.target.checked)
		setCheckBoxValidationAlert('')
	};
	const handleAgreeCheckboxChange = (e) => {
		setIsAgreedChecked(e.target.checked)
		setAgreedCheckBoxValidationAlert('')
	};
	const handlePersonaChange = (selectedValue) => {
		setSelectedPersona(selectedValue);
		setPersonaValidationError("");
	};

	const handleBrandChange = (selectedValue) => {
		setSelectedBrand(selectedValue);
		// setSelectedBrand({id : selectedValue.id, title: selectedValue.title});
		setBrandValidationError("");
	};

	const handleKYCChange = (selectedValue) => {
		setSelectedKYC(selectedValue);
		setUser({
			nameKYC: "",
			mobile: user.mobile,
			selectKYC: selectedValue.id,
			kycDetails: "",
			email: user.email,
		});
		setKycValidationError("");
		setKycDetailsValidationError("");
		// Reset all KYC-related fields
		setPanImage(null);
		setFrontImage(null);
		setBackImage(null);
		setProfileImage(null);
	};

	const handleMobileInput = (e) => {
		setUser(p => ({ ...p, [e.target.name]: e.target.value }));
		if(e.target.name === "mobile"){
			let sanitizedValue = e.target.value.replace(/[^0-9]/g, '');
			if (sanitizedValue.length > 10) {
				sanitizedValue = sanitizedValue.slice(0, 10);
			}
			e.target.value = sanitizedValue;
			setMobileValidationError("");
			setMobile(e.target.value);
			setUser({
				nameKYC: "",
				// mobile: "",
				selectKYC: "",
				kycDetails: "",
				email: "",
				refeferalCode: ""
			})
			setFullName({})
			setIsKycPrefilled(true)
			setPanImage(null)
			setFrontImage(null)
			setBackImage(null)
			setKycType({})
			// setdocumentType({})
			setSelectedKYC({})
			
		}
	}

	const handleRegistrationInputs = (e) => {
		setUser(p => ({ ...p, [e.target.name]: e.target.value }));
		if (e.target.name === "nameKYC") {
			let sanitizedValue = e.target.value.replace(/[^a-zA-Z\s]/g, '');
			e.target.value = sanitizedValue;
			setNameValidationError("");
		} else if (e.target.name === "mobile") {
			let sanitizedValue = e.target.value.replace(/[^0-9]/g, '');
			if (sanitizedValue.length > 10) {
				sanitizedValue = sanitizedValue.slice(0, 10);
			}
			e.target.value = sanitizedValue;

			setMobileValidationError("");
		} else if (e.target.name === "kycDetails") {
			setKycDetailsValidationError("");
		}

		//Email validation
		if (e.target.name == "email") {
			// let check = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
			// 	e.target.value
			// )
			let check = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(e.target.value)
			!check ? setEmailValidationError("Invalid email") : setEmailValidationError("")
			if (e.target.value == "") {
				setEmailValidationError("")
			}
		}
		if (selectedKYC.id === "aadharcard" && e.target.name === "kycDetails") {
			let sanitizedValue = e.target.value.replace(/\D/g, ''); 
			sanitizedValue = sanitizedValue.slice(0, 12);
			e.target.value = sanitizedValue;
			const idRegex = /^\d{12}$/; 
			if (!idRegex.test(sanitizedValue)) {
				setKycDetailsValidationError("Invalid Aadhaar card number.");
				setKycUploadBlock(false);
			} else {
				setKycDetailsValidationError(""); 
			}
		}

		// Validate KYC Voter details
		if (selectedKYC.id === "voterId" && e.target.name === "kycDetails") {
			const idRegex = /^[A-Z]{3}\d{7}$/; // Voter card regex
			if (!idRegex.test(e.target.value)) {
				setKycDetailsValidationError("Invalid Voter Id number");
				setKycUploadBlock(false);
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
		// Validate KYC driving license details
		if (
			selectedKYC.id === "driving_license" &&
			e.target.name === "kycDetails"
		) {
			const idRegex = /^[A-Za-z0-9]{1,20}$/; // Driving License card regex
			if (!idRegex.test(e.target.value)) {
				setKycDetailsValidationError("Invalid driving license number.");
				setKycUploadBlock(false);
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
		// Validate KYC PAN Card details
		if (selectedKYC.id === "pan" && e.target.name === "kycDetails") {
			const idRegex = /^[A-Z]{5}\d{4}[A-Z]$/; // PAN card regex
			if (!idRegex.test(e.target.value)) {
				setKycDetailsValidationError("Invalid PAN card number.");
				setKycUploadBlock(false);
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
	};

	function handleYes() {
		setIsModalOpen(false);
		setQuestionModalOpen(false);
		// setKycType(true)
		setFullName(mobileRes?.name);
		setSelectedUserKYC(kycType?.aadharNo || kycType?.panNo || kycType?.voterId ||kycType?.DLNo)
		if(kycType?.aadharNo){
			setSelectedKYC({
				"title": "Aadhar",
				"id": "aadharcard"
			},)
			setUser(prev => ({...prev, kycDetails: kycType?.aadharNo}))
			setSelectedUserKYC(prev => ({...prev, aadharImageFront: kycType?.aadharImageFront, aadharImageBack: kycType?.aadharImageBack}))
		}
		else if(kycType?.panNo){
			setSelectedKYC({
				"title": "PAN",
				"id": "pancard"
			},)
			setUser(prev => ({...prev, kycDetails: kycType?.panNo}))
			setSelectedUserKYC(prev => ({...prev, panImage: kycType?.panImage}))
		}
		else if(kycType?.voterId){
			setSelectedKYC({
				"title": "Voter ID",
				"id": "votercard"
			},)
			setUser(prev => ({...prev, kycDetails: kycType?.voterId}))
			setSelectedUserKYC(prev => ({...prev, voterImageFront: kycType?.voterImageFront, voterImageBack: kycType?.voterImageBack}))
		}
		else if(kycType?.DLNo){
			setSelectedKYC({
				"title": "Driver's License",
				"id": "dlcard"
			},)
			setUser(prev => ({...prev, kycDetails: kycType?.DLNo}))
			setSelectedUserKYC(prev => ({...prev, DLImageFront: kycType?.DLImageFront, DLImageBack: kycType?.DLImageBack}))
		}
		setIsKycPrefilled(false);
	}

	// Fetch KYC Info from Document Images
	const fetchInfo = async () => {
		if (user.nameKYC && user.nameKYC.trim()) {
			toast("Already validated. Name is fetched.");
			return;
		}
		if(selectedKYC.id === 'pan') {
			if(!panImage) {
				toast.error(`Please provide ${selectedKYC.title} image`);
				return;
			}
		} else {
			if(!frontImage || !backImage) {
				toast.error(`Please provide ${selectedKYC.title} front and back images`);
				return;
			}
		}

		const fd = new FormData();
		if(frontImage || panImage) {
			const img1 = frontImage ? frontImage.file : panImage.file;
			fd.append('ekyc_front_image', img1);
		}
		if(backImage) {
			const img2 = backImage.file;
			fd.append('ekyc_back_image', img2);
		}
		fd.append('KYCType', selectedKYC.fetchDocId);
		fd.append('doc_number', user.kycDetails.toUpperCase().trim());
		const [yyyy, mm, dd] = dob.split('-');
		fd.append('dob', `${dd}-${mm}-${yyyy}`.trim());
		setIsButtonLoading(true);
		try {
			const res = await RegistrationService.fetchKYCInfo(fd);
			setIsButtonLoading(false);
      
			if(res.success) {
				const data = res.response.KYCDetails;
				setUser(prev => ({...prev, nameKYC: data.name}));
				toast.success(res.message || "KYC info fetched successfully");
				setKycUploadBlock(true);
				setIsNameReadOnly(!!data.name);
				setFetchKYCInfoResponse(res);
				setDisabledBlock(false);
			} else {
				toast.error(res.response?.message || 'Unable to fetch KYC info from the document images. Please enter details manually.');
				setKycUploadBlock(false);
				setIsNameReadOnly(false);
				setFetchKYCInfoResponse(null);
				setDisabledBlock(false);
				setDisabledBlock(true);
			}
		} catch(err) {
			setIsButtonLoading(false);
			toast.error(err?.message || 'Error while fetching KYC info');
			setKycUploadBlock(false);
			setIsNameReadOnly(false);
			setFetchKYCInfoResponse(null);
			setDisabledBlock(true);
		}
	};

	//Preview Button
	const submitHandler = async () => {
		if(!selectedBrand.id) {
			return toast.error("Select brand");
		}
		if(!selectedPersona.id) {
			return toast.error("Select member type");
		}
		if (!user.nameKYC?.trim() && !fullName?.trim()) {
			return toast.error("Kindly enter your name");
		  } 
		if(!mobile || !isValidMobileNumber(mobile)) {
			return toast.error("Kindly enter a valid mobile number");
		}
		if(!user.kycDetails || !validateDoc(selectedKYC, user.kycDetails)) {
			return toast.error(`Kindly enter valid ${selectedKYC.title} details`);
		}
		if(!selectedBrand.id) {
			return toast.error("Kindly enter KYC Type");
		}
		const documentImgUrl = fetchIdentityImage(kycType); 
		if(selectedKYC.title == 'PAN' && (!panImage && !documentImgUrl)) {
			return toast.error("Kindly upload PAN image");
		}
		const documentImageUrl = fetchIdentityImage(kycType);
		const documentImageBack = fetchIdentityImage(kycType, "back"); 
		if(selectedKYC.title != 'PAN' && ((!frontImage || !backImage) && (!documentImageUrl || !documentImageBack))) {
			return toast.error("Kindly upload both the front and back KYC image");
		}
		// if(!profileImage) {
		// 	return toast.error("Kindly upload the profile image");
		// }
		if(!dob) {
			return toast.error("Kindly choose DoB");
		}
		if(maritalStatus.id == 'Married' && !address.spouse) {
			return toast.error("Kindly enter spouse name");
		}
		if(maritalStatus.id == 'Married' && !spouseDob) {
			return toast.error("Kindly enter spouse DoB");
		}
		if(maritalStatus.id == 'Married' && !anniversary) {
			return toast.error("Kindly enter anniversary date");
		}
		if(!address.line) {
			return toast.error(`Kindly enter ${userInfo && userInfo.userData.description == "TSE" ? "address 1" : "address"}`);
		}
		if(userInfo && userInfo.userData.description == "TSE" && !address.line2) {
			return toast.error("Kindly enter address 2");
		}
		if(userInfo && userInfo.userData.description == "TSE" && !address.line3) {
			return toast.error("Kindly enter address 3");
		}
		if(!contentState.id) {
			return toast.error("Kindly choose state");
		}
		if(!contentDistrict.id) {
			return toast.error("Kindly enter district");
		}
		if(!contentTaluka.id) {
			return toast.error("Kindly enter taluka");
		}
		if(!address.pincode || !validatepincode(address.pincode)) {
			return toast.error("Kindly enter a valid pincode");
		}
		if(!dealerTSEList.id) {
			return toast.error(`Kindly choose ${selectedTitle === 'TSE' ? 'Dealer' : 'TSE/TE'}`);
		}
		if((!isChecked || !isAgreedChecked)) {
			return toast.error(`You need to agree with both the terms and conditions`);
		}
		

		
		handleRegister();

	};

	//Register Button
	async function handleRegister() {
		try {
			if(userExists){
				let payloadObj = {}
				payloadObj = {
					created_by: parseInt(userInfo.userData.dcm_contacts_id),
					contact_id: mobileRes.contact_id,
					brand_id: parseInt(selectedBrand.id),
					hierarchies_id: parseInt(selectedPersona.id),
					organization_Id: 2,
					taluka_id: contentTaluka.id,
				}
				if(userInfo.userData.description == 'TSE'){
					Object.assign(payloadObj, {dealer_arr: [dealerTSEList.id]})
				} else {
					Object.assign(payloadObj, {tse_id: dealerTSEList.id});
				}
				RegistrationService.enrollMultibrandByTseDealer(payloadObj)
				.then((res) => {
					if (res.success == false) {
						setIsButtonLoading(false)
						setShowAlert(true);
						setIsLoginSuccess({ isLogin: false, text: res.message });
						setIsButtonLoading(false)
						let errorMessage = [];
						for (let i in res.response.error) {
							errorMessage.push(
								<span key={i}>
									{res.response.error[i]}
									<br />
								</span>
							);

						}
					} else {
						toast.success("Registration successfull")
						navigate('/landing')
						setIsButtonLoading(false)
						
					}
				})
				.catch((error) => {
					setIsButtonLoading(false)
					if(error.response?.error){
						const errKeys = Object.keys(error.response.error);
						errKeys.forEach(key => {
							toast.error(error.response.error[key])
						})
					} else {
						toast.error("Something went wrong");
					}
				})
				

			} else {
			const payload = {
				full_name: user.nameKYC || fullName,
				mobile_number: user.mobile || mobile,
				date_of_birth: dob,
				email_address: user.email ? user.email : '',
				organization_Id: 2,
				gender: 'M',
				hierarchies_id: parseInt(selectedPersona.id),
				createdby_hierarchies_id: String(userInfo.userData.dcm_hierarchies_id),
				created_by: String(userInfo.userData.dcm_contacts_id),
				identity_number: user.kycDetails,
				identity_number_type: selectedKYC.id,
				marital_status: maritalStatus.id,
				company_establishment_name: 'TSS',
				GSTN: '',
				sap_code: null,
				is_approved: null,
				approved_by: null,
				dcm_languages_id: null,
				can_redeem: null,
				approved_at: null,
				verified_by: '0',
				brand_Id: parseInt(selectedBrand.id),

				active_sites: '4',
				address: address.line,
				taluka_id: contentTaluka.id,
				city_id: contentDistrict.id,
				// contact_id: contactId,
				country_id: contentCountry.id,
				state_id: contentState.id,
				brand_id: parseInt(selectedBrand.id),
				marital_status: maritalStatus.id,
				spouse_name: address.spouse ? address.spouse : '',
				spouse_birthday: spouseDob ? spouseDob : '',
				marraige_anniversary: anniversary
				? anniversary
				: '',
				date_of_birth: dob,
				identity_number: fetchKYCInfoResponse?.response?.KYCDetails?.documentNumber,
      			frontFilePath: fetchKYCInfoResponse?.response?.KYCDetails?.frontFilePath,
      			backFilePath: fetchKYCInfoResponse?.response?.KYCDetails?.backFilePath,
      			identity_number_type: fetchKYCInfoResponse?.response?.KYCDetails?.kycType,
      			details: JSON.stringify(fetchKYCInfoResponse?.response?.KYCDetails?.details),
      			doccument_json: JSON.stringify(fetchKYCInfoResponse?.response?.KYCDetails?.doccument_json),
			  };

			  if(userInfo.userData.description == "Dealer") {
				Object.assign(payload, {tse_id: dealerTSEList.id,})
			  } else if(userInfo.userData.description == "TSE") {
				Object.assign(payload, {dealer_arr: [dealerTSEList.id], post_office: address.line2,
					landmark: address.line3,
					pin_code: address.pincode,})
			  }

			
			setIsButtonLoading(true)
			RegistrationService.enrollByTseDealer(payload, userInfo.userData.description)
				.then((res) => {
						if (res.success == false) {
						setIsButtonLoading(false)
						// Show success/error message box and set message
						setShowAlert(true);
						setIsLoginSuccess({ isLogin: false, text: res.message });
						setIsButtonLoading(false)
						let errorMessage = [];
						for (let i in res.response.error) {
							errorMessage.push(
								<span key={i}>
									{res.response.error[i]}
									<br />
								</span>
							);

						}
						// setErrorMessagesAfterRegistration(errorMessage);
						// setTimeout(() => {
						// 	setShowRegistrationAlert(false);
						// }, 3000);
					} else {

						if (profileImage && profileImage.file) {
							const profileFormData = new FormData();
							profileFormData.append("contact_id", res.response.data.id);
							profileFormData.append("profile_image", profileImage.file);
							RegistrationService.uploadProfileImageNode(profileFormData)
								.then(profileRes => {
								})
								.catch(profileErr => {
									if (window && window.toast) {
										toast.error("Profile image upload failed: " + (profileErr?.message || "Unknown error"));
									}
								});
						} else {
							if (window && window.toast) {
								toast.error("Profile image or file missing, not uploading.");
							}
						}
						const formData = new FormData();

						if (selectedKYC.id == "pan") {
							if (panImage) {
								formData.append("pan_image", panImage.file);
							}
						} else {
							if (frontImage) {
								formData.append("front_image", frontImage.file);
							}

							if (backImage) {
								formData.append("back_image", backImage.file);
							}
						}

						formData.append("KYCType", selectedKYC.id);
						formData.append("KYCDetails", user.kycDetails);
						formData.append("contact_id", res.response.data.id);
						formData.append('profile_image', profileImage.file);
						// return;
						// setIsSelectedBrand(selectedBrand.id)
						// RegistrationService.updateKYCDetails(formData).then((res) => {
						// 	//  return;
							if (res.success) {
								toast.success("Registration successful")
								navigate('/landing')
								setIsButtonLoading(false)

							} else {
								toast.error(res.response.message)
								setIsButtonLoading(false)
							}
						// }).catch(err => {

						// 	setIsButtonLoading(false);
						// });
					}
					// setIsLoginSuccess({ isLogin: true, text: res.message });
				})
				.catch((error) => {
					// toast.error("SPmething went wrong")
					setIsButtonLoading(false)
					if(error.response?.error) {
						const errKeys = Object.keys(error.response.error);
						errKeys.forEach(key => {
							toast.error(error.response.error[key]);
						})
					} else {
						toast.error("Something went wrong");
					}
				});
		}
	 } catch(err) {
			setIsButtonLoading(false)
		}
	
	};

	//Functions
	const isValidFullName = (fullName) => {
		// Ensure there are at least two words (first name and last name)
		const nameParts = fullName?.trim().split(" ");

		return nameParts.length >= 2;

	};

	const isValidMobileNumber = (mobileNumber) => {
		const mobileNumberPattern = /^(\+\d{1,3}[- ]?)?\d{10}$/;
		return mobileNumberPattern.test(mobileNumber);
	};

	const isValidKyc = (selectKYC, kycDetails) => {

		// Validate KYC Adhar details
		if (selectKYC === "aadharcard") {
			const idRegex = /^[a-zA-Z0-9]{12}$/; // Aadhar card regex
			if (!idRegex.test(kycDetails)) {
				setKycDetailsValidationError("Invalid aadhar card number.");
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
		// Validate KYC Voter details
		if (selectKYC === "voterId") {
			const idRegex = /^[A-Z]{3}\d{7}$/; // Voter card regex
			if (!idRegex.test(kycDetails)) {
				setKycDetailsValidationError("Invalid Voter Id number");
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
		// Validate KYC driving license details
		if (selectKYC === "driving_license") {
			const idRegex = /^[A-Za-z0-9]{1,20}$/; // Driving License card regex
			if (!idRegex.test(kycDetails)) {
				setKycDetailsValidationError("Invalid driving license number.");
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}
		// Validate KYC PAN Card details
		if (selectKYC === "pan") {
			const idRegex = /^[A-Z]{5}\d{4}[A-Z]$/; // PAN card regex
			if (!idRegex.test(kycDetails)) {
				setKycDetailsValidationError("Invalid PAN card number.");
			} else {
				setKycDetailsValidationError(""); // Reset error message if validation passes
			}
		}

		if(kycDetailsValidationError !== ''){

			return false;
		} else {
			return true;
		}
	}

	// Handle KYC Details
	const handleVerifyKyc = () => {

		if (!user.selectKYC) {
			setKycValidationError("KYC type is required.");
		} else {
			setKycValidationError("");
		}
		if (!user.kycDetails.trim()) {
			setKycDetailsValidationError("KYC Details is required.");
		} else {
			setKycDetailsValidationError("");
		}
		// Validate KYC
		isValidKyc(user.selectKYC, user.kycDetails);
		
		// If KYC type and KYC value is not given then do not open the upload file options.
		if (user.kycDetails.trim() != "" && user.selectKYC != "" && kycDetailsValidationError == "") {
			if (!kycDetailsValidationError) {
				setKycUploadBlock(true);
			} else {
				setKycUploadBlock(false);
			}
		} else {
			setKycUploadBlock(false);
		}
	};

	//Edit Registration
	// const handleEditRegistration = () => {
	//   setPreviewBlock(false);
	//   setRegFormBlock(true);
	// };
	const setProfileImageHandler = (profileImg) => {
		setProfileImage(profileImg)
		setProfilePicNotNotUploadedAlert("");
	}

	const setPanImageHandler = (pan) => {
		setPanImage(pan)
		setfileNotUploadedAlert("");
	}

	const setOtherKYCFrontImageHandler = (frontImage) => {
		setFrontImage(frontImage)
		setfileNotUploadedFrontAlert('')
	}
	const setOtherKYCBackImageHandler = (backImage) => {
		setBackImage(backImage)
		setfileNotUploadedBackAlert('')
	}
	// ##############################################################################################
	// ##############################################################################################

	//Country
	const [isCountryList, setIsCountryList] = useState([])
	const [contentCountry, setContentCountry] = useState({ id: '', title: '' });
	//State
	const [isStateList, setIsStateList] = useState([])
	const [contentState, setContentState] = useState({ id: "", title: "" });
	//District
	const [isDistrictList, setIsDistrictList] = useState([])
	const [contentDistrict, setContentDistrict] = useState({ id: "", title: "" });
	//City
	const [isCityList, setIsCityList] = useState([])
	const [contentCity, setContentCity] = useState({ id: "", title: "" });
	//Taluka
	const [isTalukaList, setIsTalukaList] = useState([])
	const [contentTaluka, setContentTaluka] = useState({ id: "", title: "" });
	const [dealerTSE, setDealerTSE] = useState({ id: "", title: "" });
	//Marital Status
	// const [maritalStatus, setMaritalStatus] = useState({ id: "", title: "" });
	// const [isLoginSuccess, setIsLoginSuccess] = useState({ isLogin: true, heading: '', text: '' })
	// const [showAlert, setShowAlert] = useState(false);
	const [loading, setLoading] = useState(true);
	const [dob, setDob] = useState('')
	const [spouseDob, setSpouseDob] = useState('')
	const [anniversary, setAnniversary] = useState('')
	//Address Status
	const [address, setAddress] = useState(
		{

			line: '',
			line2: '',
			line3: '',
			spouse: '',
			pincode: ''

		}
	)
	//BrandId
	const [isSelectedBrand, setIsSelectedBrand] = useState('')
	//ContactId

	//Validation Error//

	const [isStateValidationError, setIsStateValidationError] = useState('');
	const [isDistrictValidationError, setIsDistrictValidationError] = useState('');

	const [isTalukaValidationError, setIsTalukaValidationError] = useState('');
	const [allDistrictCopy, setAllDistrictCopy] = useState([])
	const [isMaritalStatusValidationError, setIsMaritalStatusValidationError] = useState('')
	const [isDOBValidationError, setIsDOBValidationError] = useState('')
	const [dealerTSEList, setDealerTSEList] = useState({ id: "", title: "" })
	const [canUpdate, setCanUpdate] = useState(true)
	const [contactId, setContactId] = useState('');
	const [brandId, setBrandId] = useState('');
	const [isAddressValidationError, setIsAddressValidationError] = useState('');
	const [isSpouseValidationError, setIsSpouseValidationError] = useState('');
	const [isSpouseDOBValidationError, setIsSpouseDOBValidationError] = useState('');
	const [isSpouseValidationAnniError, setIsSpouseValidationAnniError] = useState('');
	const [isTSEListValidationError, setIsTSEListValidationError] = useState('');
	const [isDealerListValidationError, setIsDealerListValidationError] = useState('');
	const [selectedTitle, setSelectedTitle] = useState('');
	const [description, setDescription] = useState('');
	//DealerTseList
	const [dealerOrTseList, setDealerOrTseList] = useState([])
	//  ---------------------------
	const [basicRegistrationDealerBlockShow, setBasicRegistrationDealerBlockShow] = useState(false)
	const [membertypelist, setMembertypeList] = useState([]);
	const [dropkyctype, serDropKyctype] = useState([]);
	const [allTalukaCopy ,setAllTalukaCopy] = useState([]);
;	const [isKYCEditable, setIsKYCEditable] = useState(true); 
	const [isKycPrefilled, setIsKycPrefilled] = useState(true);
	// const [hier]

	useEffect(() => {
		// setMembertypeList(ProductDrop);
		serDropKyctype(documentType);
	}, []);

	useEffect(() => {
		if (!registrationHierarchiesDetails || registrationHierarchiesDetails.length === 0) {
			return;
		}
		const hier = registrationHierarchiesDetails.map((item) => {
			return {
				id: item.id,
				title: item.name,
			};
		});
		setMembertypeList(hier);
	}, [registrationHierarchiesDetails]);

	//Local Storage
	useEffect(() => {
		const userInfo = JSON.parse(localStorage.getItem('userData'));
		const selectedTitle = userInfo?.title;
		const contactId = userInfo?.dcm_contacts_id;
		const brandId = currentBrand.id;
		setHierDesc(userInfo?.description);
		setContactId(contactId);
		setBrandId(brandId);
		setSelectedTitle(selectedTitle)
	}, [])
	//Basic Profile Info
	useEffect(() => {
		const basicProfileInfo = async () => {
			try {
				const token = localStorage.getItem('access_token')
				const response = await RegistrationService.getBasicProfileInfo(token);
				dispatch(addBasicProfileDetails({
					basicProfileDetails: response.response.basicProfileDetails,
					canUpdate: response.response.canUpdate,
				}))
			}
			catch (e) {
				console.error('Error fetching profile info:');
			}

		}
		basicProfileInfo()
	}, [])
	//All Countries
	useEffect(() => {
		const fetchCountryData = async () => {
			try {
				const response = await RegistrationService.allCountries();
				if (response.success === true && response.response.countriesDetails.length > 0) {
					const countryNames = response.response.countriesDetails.filter(item =>
						['India'].includes(item.name),
					).map(country =>
					(
						{
							id: country.id,
							title: country.name
						}
					)
					);
					setContentCountry(countryNames[0])
					setLoading(false)
				}

			}
			catch (error) {
				console.error('Error fetching country data:');
			}
		};
		fetchCountryData()
	}, [])

	// Get all state district taluka as per TSE
	// useEffect(() => {
	// 	const stateListFetch = async () => {

	// 		try {
	// 			const token = localStorage.getItem('access_token')
	// 			const stateListResponse = await RegistrationService.getStateDistrictTaluka(token);

				
	// 			if (stateListResponse.success === true) {
	// 				// Set state
	// 				if (stateListResponse.response.state.length > 0) {
	// 					const statesDetails = stateListResponse.response.state;
	// 					const filteredState = statesDetails.map((item) => ({
	// 						id: item.stateId,
	// 						title: item.name
	// 					}));
	// 					setIsStateList(filteredState);
	// 					if(filteredState.length === 1) {
	// 						setContentState(filteredState[0])
	// 					}
						
	// 					setLoading(false)
	// 				}

	// 				// Set District
	// 				if (stateListResponse.response.districts.length > 0) {
	// 					const filteredDitrict  =stateListResponse.response.districts.map((item) => ({
	// 						id: item.districtsID,
	// 						title: item.districtsName
	// 					}
	// 					));
	// 					setIsDistrictList(filteredDitrict);
	// 					if(filteredDitrict.length === 1) {
	// 						setTimeout(() => {
	// 							setContentDistrict(filteredDitrict[0]);
	// 						}, 400)
	// 					}
	// 					setLoading(false)
	// 				}

	// 				// Set Taluka
	// 				if (stateListResponse.response.talukas.length > 0) {
	// 					const filteredTaluka = stateListResponse.response.talukas.map((item) => ({
	// 						id: item.talukaId,
	// 						title: item.talukaName
	// 					}
	// 					))
	// 					setIsTalukaList(filteredTaluka)
	// 					if(filteredTaluka.length === 1) {
	// 						setTimeout(() => {
	// 							setContentTaluka(filteredTaluka[0]);
	// 						}, 800)
	// 					}
	// 					setLoading(false)
	// 				}

	// 			}

	// 		} catch (error) {

	// 		}

	// 	};

	// 	stateListFetch();
	// }, []);

useEffect(() => {
  if (!basicProfileDetails || JSON.stringify(basicProfileDetails) === '{}') {
    setInfoLoading(false);
    return;
  }

  const userDetails = basicProfileDetails;

  setAddress(`${userDetails.line1} ${userDetails.line2} ${userDetails.line3}`);
  setAddress2(userDetails.line2);
  setAddress3(userDetails.line3);
  setPincode(userDetails.post_code);

  setCountry({
    id: userDetails.dcm_countries_id,
    title: userDetails.dcm_countries_name,
  });

  setState({
    id: userDetails.dcm_states_id,
    title: userDetails.dcm_states_name,
  });

  setCity({
    id: userDetails.dcm_cities_id,
    title: userDetails.city,
  });

  setDistrict({
    id: userDetails.dcm_districts_id,
    title: userDetails.dcm_district_name,
  });

  setSelectedTaluka({
    id: userDetails.dcm_taluka_id,
    title: userDetails.dcm_taluka_name,
  });

  setSelectedBranch({
    id: userDetails.branch_id,
    title: userDetails.branch_names?.[0],
  });

  setSelectedTso({
    id: userDetails.tso_id,
    title: userDetails.tso_name,
  });

  setspouseName(userDetails.spouse_name);
  setDob(userDetails.date_of_birth?.value);
  setdate_of_birth(userDetails.spouse_birthaDay);
  setdate_of_anniversary(userDetails.marraige_Anniversary);

  setmaritalStatusNew({
    id: userDetails.marital_status,
    title: userDetails.marital_status,
  });

  setSelectedOfficer({
    id: userDetails.select_TSE_or_Dealer,
    title: userDetails.select_TSE_or_Dealer,
  });

  setSelectedOffMember({
    id: '',
    title: userDetails.dealer_name,
  });

  setInfoLoading(false);
}, [basicProfileDetails]);

const token = localStorage.getItem('access_token')
// const hierDesc = JSON.parse(localStorage.getItem('userData')).hierCode;

// useEffect (() => {
// 	if(district?.id){
// 		const res = RegistrationService.talukasByDistrict(district.id);

// 		if(res.success){
// 			const talukas = res.response.talukaDetails.map(item => ({
// 				title: item.name, 
// 				id: item.id
// 			}));
// 			if(hierDesc !== 'Dealer' && hierDesc !== 'TSE'){
// 				setAllTaluka(talukas);
// 			} else {
// 				setAllTalukaCopy(talukas);
// 			}
// 		}
// 	}
// }, [district, hierDesc]);

useEffect (() => {
	const fetchTalukas = async () => {
	try {
		if(district?.id){
		const res = await RegistrationService.talukasByDistrict(district.id);
		if(res.success){
			const talukas = res.response.talukaDetails.map(item => ({
				title: item.name, 
				id: item.id
			}));
			if(hierDesc !== 'Dealer' && hierDesc !== 'TSE'){
				setAllTaluka(talukas);
			} else {
				setAllTalukaCopy(talukas);
			}
		}
	    }
	} catch (error) {
		console.error("Error fetching data:");
	}
	};
    fetchTalukas();
}, [city, state, country, district, hierDesc]);
	
	useEffect(() => {
		const applyLocationData = (locationResponse) => {
			const states = locationResponse.state
				.filter(item => item.brandId == currentBrand.id)
				.map(item => ({title: item.name, id: item.stateId}));

			setIsStateList(states);

			const districts = locationResponse.districts
				.filter(item => item.brandId == currentBrand.id)
				.map(item => ({
					title: item.districtsName,
					id: item.districtsID,
				}));

			const distArr = [];
			districts.forEach(item => {
				allDistrictCopy.forEach(dist => {
					if (dist.id == item.id) {
					  distArr.push(dist);
					}
				});
			});
			if(distArr.length == 1){
				setContentDistrict(distArr[0]);
			}


			setAllDistrict(distArr);

			const talukas = locationResponse.talukas
				.filter(item => item.brandId == currentBrand.id)
				.map(item => ({
					title: item.talukaName,
					id: item.talukaId
				}));


			const talArr = [];
			talukas.forEach(item => {
				allTalukaCopy.forEach(taluka => {
					if (taluka.id == item.id) {
					  talArr.push(taluka);
					}
				});
			});
			if(talArr.length == 1){
				setContentTaluka(talArr[0]);
			}

			setAllTaluka(talArr);
		};

		const stateListFetch = async () => {
			try {
				if (token && (hierDesc == 'Dealer' || hierDesc == 'TSE'))
				{
					if (locationData.state.length || locationData.districts.length || locationData.talukas.length) {
						applyLocationData(locationData);
						return;
					}

					const res = await RegistrationService.getLocationData(token);

					if (res.success) {
						dispatch(addLocationData(res.response));
						applyLocationData(res.response);
				    }
				}
			} catch (error) {
			}
		};
		stateListFetch();
	}, [state, token, hierDesc, allDistrictCopy, allTalukaCopy, locationData]);

useEffect(() => {
  const fetchDistricts = async () => {
    try {

      if (state?.id && country?.id) {
        const res = await RegistrationService.allDistricts(country.id, state.id);
		
        if (res.success) {
          const districts = res.response.districtDetails.map(dis => ({
            id: dis.id,
            title: dis.name,
          }));

          if (hierDesc !== 'Dealer' && hierDesc !== 'TSE') {
			
            setAllDistrict(districts);
          } else {
			
            setAllDistrictCopy(districts);
          }
        }
      }
    } catch (error) {
      console.error('Failed to fetch districts:');
    }
  };

  fetchDistricts();
}, [city, state, country, hierDesc]);

	//All City
	useEffect(() => {
		const fetchCityList = async () => {
			if (contentCountry.id && contentState.id) {
				try {
					const cityListResponse = await RegistrationService.allCities(contentCountry.id, contentState.id);
					if (cityListResponse.success === true && cityListResponse.response.citiesDetails.length > 0) {
						setIsCityList(cityListResponse.response.citiesDetails.map((item) =>
						(
							{
								id: item.id,
								title: item.name
							}
						)
						))
						setLoading(false)
					}
				}
				catch (error) {
					console.error("Error")

				}
			}
		}
		fetchCityList()
	}, [contentCountry.id, contentState.id]);

	const isMaritalList = [
		{
			id: 'Married',
			title: 'Married',
		},
		{
			id: 'Single',
			title: 'Single',
		},
	]
	//Dealer/TSE List//

	useEffect(() => {
		const DealerTSEListFetch = async () => {

			try {
				const token = localStorage.getItem('access_token')
				const officerId = selectedTitle === 'TSE' ? 'Dealer' : 'TSE';
				const districtId = contentDistrict.id
				const talukId = contentTaluka.id
				const userInfo = JSON.parse(localStorage.getItem('userData'));
				const brandId = selectedBrand.id;
				const payload = { "userContactId": 0 }
				if(officerId && districtId && talukId && brandId) {
					const res = await RegistrationService.getDealersOrTse(officerId, contentDistrict.id, contentTaluka.id, brandId, payload)
					// if (DealerTSEListResponse.success === true && DealerTSEListResponse.response.adminDetails.length > 0) {
					// 	setDealerOrTseList(DealerTSEListResponse.response.adminDetails.map((item, index) => {
					// 		return (
					// 			{
					// 				id: item?.id,
					// 				title: item?.full_name
					// 			}
					// 		)
					// 	}))
					// 	setLoading(false)
					// }

				let offs;

				if (officerId == 'TSE') {
					offs = res.response.adminDetails.map(off => ({
					id: off.id,
					title: off.full_name,
					}));
				} else {
					offs = res.response.adminDetails.map(off => ({
					id: off.id,
					title: `${off.full_name} (${off?.company} - ${off?.id_extern01})`,
					}));
              }

              setDealerOrTseList(offs);
              if (offs.length == 1) setDealerTSEList(offs[0]);
				}
			}
			catch (e) {
				console.error('DealerTSEListResponse Error');
			}
		}
		DealerTSEListFetch()
	}, [selectedTitle, contentDistrict, contentTaluka, selectedBrand])

	const handleContentStateNameChange = (selected) => {
		setContentState(selected)
		setState(selected)
		setIsStateValidationError('')
	}
	const handleContentDistrictNameChange = (selected) => {
		setContentDistrict(selected)
		setIsDistrictValidationError('')
	}
	const handleContentTalukaNameChange = (selected) => {
		setContentTaluka(selected)
		setIsTalukaValidationError('')
	}
	const handleMaritalStatusOptionChoose = (selected) => {
		setMaritalStatus(selected)
		setIsMaritalStatusValidationError('')
	}
	const handleContentDealerOptionListChoose = (selected) => {
		setDealerTSEList(selected)
		setIsDealerListValidationError('')
		setIsTSEListValidationError('')
	}
	const handleBasicRegistrationInput = (e) => {
		
		setAddress({ ...address, [e.target.name]: e.target.value })
		switch (e.target.name) {
			case 'line':
				setIsAddressValidationError('');
				break;
			case 'dob':
				setIsDOBValidationError('');
				break;
			case 'spouse':
				setIsSpouseValidationError('');
				break;
			case 'spouseDOB':
				setIsSpouseDOBValidationError('');
				break;
			case 'anniversaryDOB':
				setIsSpouseValidationAnniError('');
				break;
		}

	}

	function handleClose() {
		setQuestionModalOpen(false);
		setUser(p => ({ ...p, mobile: ''}));
		setMobile('');
		setSelectedPersona({id: '', title: ''});
		setExistInSameBrand(false);
        setHiertype({id: '', title: ''});
	}

	  const handleNo = () => {
		setIsModalOpen(false);
		setUser(p => ({ ...p, mobile: ''}));
		setMobile('');
		setSelectedPersona({id: '', title: ''});
		setKycType(false);
	  };
    const fetchIdentityImage = (kycType, type='front') => {
        if(kycType.voterImageBack && type=='back') return kycType.voterImageBack;
		if(kycType.voterImageFront && type=='front') return kycType.voterImageFront;
		if(kycType.aadharImageFront && type=='front') return kycType.aadharImageFront;
		if(kycType.aadharImageBack  && type=='back') return kycType.aadharImageBack;
		if(kycType.DLImageFront && type=='front') return kycType.DLImageFront;	
		if(kycType.DLImageBack  && type=='back') return kycType.DLImageBack;
		if(kycType.panImage) return kycType.panImage;
	}

	useEffect(() => {
	
		  if (contentState.id && contentCountry.id) {
			RegistrationService.allDistricts(contentCountry.id, contentState.id).then(
			  res => {
				if (res.success) {
				  const districts = res.response.districtDetails.map(dis => ({
					id: dis.id,
					title: dis.name,
				  }));
				  if (hierDesc !== 'Dealer' && hierDesc !== 'TSE') {
					setIsDistrictList(districts);
				  } else {
					setAllDistrictCopy(districts);
				  }
				}
			  },
			);
		  }
	  }, [contentState, contentCountry, hierDesc]);

	  useEffect(() => {
		// setSelectedTaluka({id: "", title: ""})
		// if (contentDistrict.id) {
		//   EncryptedStorage.getItem('my-key').then(token => {
			if (contentDistrict.id) {
			  RegistrationService.talukasByDistrict(contentDistrict.id).then(
				res => {
				  if (res.success) {
					const talukas = res.response.talukaDetails.map(taluka => ({
					  id: taluka.id,
					  title: taluka.name,
					}));
					if (hierDesc !== 'Dealer' && hierDesc !== 'TSE') {
					  setIsTalukaList(talukas);
					} else {
					  setAllTalukaCopy(talukas);
					}
				  }
				},
			  );
			} else {
			  setIsTalukaList([]);
			  setContentTaluka({id: '', title: ''});
			}
		//   });
		// }
	  }, [contentDistrict, hierDesc]);

	  useEffect(()=> {
		  
	  },[isKycPrefilled])

		useEffect(() => {

			const applyLocationData = (locationResponse) => {
				const states = locationResponse.state
					.filter(item => item.brandId == brandId)
					.map(item => ({title: item.name, id: item.stateId}));


				setIsStateList(states);
				if (states.length == 1 && !contentState.id) {
					setContentState(states[0]);
				}


				const districts = locationResponse.districts
					.filter(item => item.brandId == brandId)
					.map(item => ({
					  title: item.districtsName,
					  id: item.districtsID,
					}));



				const distArr = [];
				districts.forEach(item => {
					allDistrictCopy.forEach(dist => {

						if (dist.id == item.id) {
							distArr.push(dist);
						}
					});
				});

				const talArr = [];
				const talukas = locationResponse.talukas
					.filter(item => item.brandId == brandId)
					.map(item => ({title: item.talukaName, id: item.talukaId}));
				talukas.forEach(item => {
					allTalukaCopy.forEach(taluka => {
					  if (taluka.id == item.id) {
						talArr.push(taluka);
					  }
					});
				});

				setIsDistrictList(distArr);
				setIsTalukaList(talArr);
				if (distArr.length == 1) {
					setContentDistrict(distArr[0]);

					if (talArr.length == 1) {
					  setContentTaluka(talArr[0]);
					}
				}

				if (contentDistrict.id && talArr.length == 1) {
					setContentTaluka(talArr[0]);
				}
			};

			if ((hierDesc == 'Dealer' || hierDesc == 'TSE' || hierDesc == 'Retailer' || hierDesc == 'ARS' )) {
			  if (locationData.state.length || locationData.districts.length || locationData.talukas.length) {
				applyLocationData(locationData);
			  }
			}
		}, [hierDesc, allDistrictCopy, allTalukaCopy, brandId, locationData])
	  
	return (
		<>
			<BreadCrumbSecttion pageTitle="Enroll" currentPageName="Enroll" />
			{!basicRegistrationDealerBlockShow &&
				<section className="padTop50">
					<Container>
						<Row className="justify-content-center align-item-center h-100 enrollMember">
							<Col xs={12}>
								<div className="userInfoBox">
									{/* <div className="dashboard-title">
										<h4 className="gradient-text">Please Enroll New Member</h4>
									</div> */}
									<div className="dashboard-details">
										<Row>
										{userInfo && userInfo.userData.description == "TSE" && <Col xs={12} lg={4}>
												<SelectDropDown
													labelName="Select Brand"
													requiredStar="*"
													options={isbrand}
													onChange={handleBrandChange}
													selectedValue={selectedBrand}
													setSelectedValue={setSelectedBrand}
													required
													disabled={true} 
												/>
												{/* {brandValidationError && (
													<div className="error-message">
														{brandValidationError}
													</div>
												)} */}
											</Col>}
											<Col xs={12} lg={4}>
												<SelectDropDown
													labelName="Member Type"
													requiredStar="*"
													options={persona}
													onChange={handlePersonaChange}
													selectedValue={selectedPersona}
													setSelectedValue={setSelectedPersona}
													required
													page='searchFilter'
												/>
												{/* {personaValidationError && (
													<div className="error-message">
														{personaValidationError}
													</div>
												)} */}
											</Col>

											<Col xs={12} lg={4}>
														<InputField
															inputFieldLabel="Mobile No"
															requiredStar="*"
															autocomplete="off"
															value={mobile}
															// onChange={handleRegistrationInputs}
															onChange={handleMobileInput}

															name="mobile"
														/>
														{mobileValidationError && (
															<div className="error-message">
																{mobileValidationError}
															</div>
														)}
													</Col>
											<Row>
											{/* new line */}

											<Col xs={12} lg={4}>
												<DatePicker
													inputFieldLabel="DOB"
													requiredStar="*"
													name="dob"
													value={dob}
													onChange={setDob}
													dobSelection
												/>
												{/* {isDOBValidationError && (
													<div className="error-message">{isDOBValidationError}</div>
												)} */}
											</Col>

											{<Col xs={12} lg={4}>
												<SelectDropDown
													labelName="KYC Type"
													requiredStar="*"
													options={documentTypeOptions}
													onChange={handleKYCChange}
													selectedValue={selectedKYC}
													setSelectedValue={setSelectedKYC}
													name="selectKYC"
													// disabled={!!selectedKYC?.title}
												/>

												{/* {kycValidationError && (
													<div className="error-message">{kycValidationError}</div>
												)} */}
											</Col>}

											{/* KYC Type and details */}

											<Col xs={12} lg={4} className="upperKYCDetails">
											<InputField
  												inputFieldLabel="KYC Details"
  												requiredStar="*"
  												autocomplete="off"
  												value={user.kycDetails}
  												onChange={handleRegistrationInputs}
  												name="kycDetails"
  												required
  												// disabled={!isKycPrefilled}
												editable={isKycPrefilled}
											/>
												{/* {kycDetailsValidationError && (
													<div className="error-message mb-4">
														{kycDetailsValidationError}
													</div>
												)} */}
											</Col>

												<Row>
												  {selectedKYC?.title ? ( 
  													!(kycType.aadharImageFront || kycType.voterImageFront || kycType.DLImageFront || kycType.panImage) 
    													? selectedKYC.title === "PAN" 
     														 ? (
																<>
																<Col xs={12} lg={4} >
																<UploadFile
																	key={`pan-${selectedKYC.id || ''}`}
																	label="Upload PAN"
																	requiredStar="*"
																	accept="image/jpeg, image/jpg, image/png"
																	value={panImage}
																	setValue={setPanImage}
																/>
																</Col>
																</>
        													) 
      														: (
															<Col xs={12} lg={4} >
															<UploadFile
																key={`front-${selectedKYC.id || ''}`}
																label={`Upload front ${selectedKYC.title}`}
																requiredStar="*"
																accept="image/jpeg, image/jpg, image/png"
																value={frontImage}
																setValue={setFrontImage}
															/>
															</Col>
        													)
   														 : (
        													<Col xs={12} lg={4}>
          														<DocumentImage 
            														imageUrl={fetchIdentityImage(kycType)} 
            														title={`${selectedKYC?.title || 'Document'} Front`} 
          														/>
        													</Col>
      													)
													) : null} 

												{selectedKYC.title && selectedKYC.title !== "PAN" && (!(kycType.aadharImageBack || kycType.voterImageBack || kycType.DLImageBack) ? (
  												<Col xs={12} lg={4} >
													<UploadFile
														key={`back-${selectedKYC.id || ''}`}
														label={`Upload back ${selectedKYC.title}`}
														requiredStar="*"
														accept="image/jpeg, image/jpg, image/png"
														value={backImage}
														setValue={setBackImage}
													/>
  												</Col>
												) : (
													<Col xs={12} lg={4}>
													  {/* <img src={fetchIdentityImage(kycType)} alt="Back KYC" width="100" /> */}
													  <DocumentImage imageUrl={fetchIdentityImage(kycType, 'back')} title={`${selectedKYC?.title || 'Document'} Back`} />

											        </Col>
											))}

										{selectedKYC.id && (
										<Col xs={12} lg={4}>
										<UploadFile
											key={`profile-${selectedKYC.id || ''}`}
											label='Profile Picture'
											requiredStar="*"
											accept="image/jpeg, image/jpg"
											value={profileImage}
											setValue={setProfileImage}
										/>
											{profilePicNotUploadedAlert && (
												<div className="error-message fileUploadMsg">
													{profilePicNotUploadedAlert}
												</div>
											)}
										</Col>
										)}

											<Col xs={12} lg={4}>
												<div style={{color: '#3B82F6', textDecoration: 'underline', cursor: 'pointer'}} onClick={fetchInfo}>
													<u>Validate Now</u>
												</div>
											</Col>
										</Row>
											{/* {selectedKYC.title == "PAN" && <UploadFile
												label="Upload PAN"
												requiredStar="*"
												accept="image/*"
												value={panImage}
												setValue={setPanImage}
											/>} */}
											{/* {selectedKYC.title !== "PAN" && selectedKYC.title && <UploadFile
												label={`Upload front ${selectedKYC.title}`}
												requiredStar="*"
												accept="image/*"
												value={frontImage}
												setValue={setFrontImage}
											/>} */}

											{/* </Col> */}
											{/* {selectedKYC.title && selectedKYC.title !== "PAN" && <Col xs={12} lg={3}>
												<UploadFile
													label={`Upload back ${selectedKYC.title}`}
													requiredStar="*"
													accept="image/*"
													value={backImage}
													setValue={setBackImage}
												/>
											</Col>} */}
										</Row>

											<Col xs={12}>
      											<SimpleModal 
        											isOpen={questionModalOpen} 
													onClose={handleClose}
        											title="Information"
        											description={description}
      											/>
    										</Col>

											<Col xs={12}>
      											<SimpleModal 
        											isOpen={isModalOpen} 
        											type="confirmation"
        											onYes={handleYes}
        											onNo={handleNo}
        											title="Confirmation"
        											description={description}
      											/>
    										</Col>

											<Col xs={12} lg={4}>
												<InputField
														key={`nameKYC-${selectedKYC.id || ''}`}
														inputFieldLabel="Name as per Govt. ID"
														requiredStar="*"
														value={user.nameKYC || (typeof fullName === "string" ? fullName : fullName?.name || "")}
														onChange={handleRegistrationInputs}
														name="nameKYC"
														autocomplete="off"
														required
														editable={
																isKycPrefilled
															}
														readOnly={isNameReadOnly}
														disabled={disabledBlock || isNameReadOnly}
												/>
												{/* {nameValidationError && (
													<div className="error-message">
														{nameValidationError}
													</div>
												)} */}
											</Col>

											<Col xs={12} lg={4}>
												<InputField
													inputFieldLabel="Email"
													value={user.email}
													onChange={handleRegistrationInputs}
													name="email"
													autocomplete="off"
													disabled={disabledBlock}
												/>
												{/* {emailValidationError && (
													<div className="error-message">
														{emailValidationError}
													</div>
												)} */}
											</Col>

											<Col xs={12} lg={4}>
												<SelectDropDown
													page='searchFilter'
													labelName='State'
													requiredStar="*"
													options={isStateList}
													selectedValue={contentState}
													setSelectedValue={setContentState}
													onChange={handleContentStateNameChange} 
													disabled={disabledBlock} />
												{/* {isStateValidationError && (
													<div className="error-message">{isStateValidationError}</div>
												)} */}

											</Col>

											<Col xs={12} lg={4}>
												<Row>
													{/* <Col xs={12}>
														<InputField
															inputFieldLabel="Mobile No"
															requiredStar="*"
															autocomplete="off"
															value={user.mobile}
															onChange={handleRegistrationInputs}
															name="mobile"
														/>
														{mobileValidationError && (
															<div className="error-message">
																{mobileValidationError}
															</div>
														)}
													</Col> */}

												</Row>

											</Col>

										</Row>
										

										{/* KYC upload block */}
										
											{/* <Row> */}
												{/* {selectedKYC.id === "pan" && (
													<Col xs={12} lg={3}>

														<UploadFile
															label="Upload PAN"
															requiredStar="*"
															accept="image/*"
															value={panImage}
															setValue={setPanImageHandler}

														/>
														{fileNotUploadedAlert && (
															<div className="error-message fileUploadMsg">
																{fileNotUploadedAlert}
															</div>
														)}
													</Col>
												)}
												{selectedKYC.id !== "pan" && (
													<> <Col xs={12} lg={3}>

														<UploadFile
															label={`Upload ${selectedKYC.title} Front`}
															requiredStar="*"
															accept="image/*"
															setValue={setOtherKYCFrontImageHandler}

														/>
														{fileNotUploadedFrontAlert && (
															<div className="error-message fileUploadMsg">
																{fileNotUploadedFrontAlert}
															</div>
														)}
													</Col>
														<Col xs={12} lg={3}>
															<UploadFile
																label={`Upload ${selectedKYC.title} Back`}
																requiredStar="*"
																accept="image/*"
																setValue={setOtherKYCBackImageHandler}

															/>
															{fileNotUploadedBackAlert && (
																<div className="error-message fileUploadMsg">
																	{fileNotUploadedBackAlert}
																</div>
															)}
														</Col>

													</>
												)} */}

											{/* <Row>
  												{!(kycType.aadharImageBack || kycType.voterImageBack || kycType.DLImageBack || kycType.panImage) && (
    												<Col xs={12} lg={3}>
     									 				<UploadFile
        													label='Profile Picture'
        													requiredStar="*"
        													accept="image/*"
        													value={profileImage}
        													setValue={setProfileImage}
      													/>
    												</Col>
  												)}
											</Row> */}

										
										<Row>
										<Row>
											<Col xs={12} lg={4}>
												<SelectDropDown
													page='searchFilter'
													labelName='District'
													requiredStar="*"
													// options={isDistrictList}
													options={allDistrict}
													selectedValue={contentDistrict}
													setSelectedValue={setContentDistrict}
													onChange={handleContentDistrictNameChange} 
													disabled={disabledBlock} />
												{/* {isDistrictValidationError && (
													<div className="error-message">{isDistrictValidationError}</div>
												)} */}
											</Col>

											<Col xs={12} lg={4}>
												<SelectDropDown labelName="Taluka"
													page='searchFilter'
													requiredStar="*"
													options={isTalukaList}
													setSelectedValue={setContentTaluka}
													selectedValue={contentTaluka}
													onChange={handleContentTalukaNameChange} 
													disabled={disabledBlock} />
											</Col>

											{!userExists && <Col xs={12} lg={4}>
												<InputField
													inputFieldLabel="Address Line 1"
													requiredStar="*"
													name="line"
													value={address.line}
													onChange={handleBasicRegistrationInput}
													disabled={disabledBlock}
												/>
												{/* {isAddressValidationError && (
													<div className="error-message">{isAddressValidationError}</div>
												)} */}
											</Col>}
											<Row>
											{!userExists && userInfo && userInfo.userData.description == "TSE" && <Col xs={12} lg={4}>
												<InputField
													inputFieldLabel="Address Line 2"
													requiredStar="*"
													name="line2"
													value={address.line2}
													onChange={handleBasicRegistrationInput}
													disabled={disabledBlock}
												/>
												{/* {isAddressValidationError && (
													<div className="error-message">{isAddressValidationError}</div>
												)} */}
											</Col>}
											{!userExists && userInfo && userInfo.userData.description == "TSE" && <Col xs={12} lg={4}>
												<InputField
													inputFieldLabel="Address Line 3"
													requiredStar="*"
													name="line3"
													value={address.line3}
													onChange={handleBasicRegistrationInput}
													disabled={disabledBlock}
												/>
												{/* {isAddressValidationError && (
													<div className="error-message">{isAddressValidationError}</div>
												)} */}
											</Col>}

											{!userExists && <Col xs={12} lg={4}>
												<InputField
													inputFieldLabel="Pincode"
													requiredStar="*"
													name="pincode"
													value={address.pincode}
													onChange={handleBasicRegistrationInput}
													disabled={disabledBlock}
												/>
												{isAddressValidationError && (
													<div className="error-message">{isAddressValidationError}</div>
												)}
											</Col>}
											</Row>

											<Col xs={12} lg={4}>
												<SelectDropDown labelName={selectedTitle === 'TSE' ? 'Dealer' : 'TSE / TE'}
													page='searchFilter'
													requiredStar="*"
													options={dealerOrTseList}
													setSelectedValue={setDealerTSEList}
													selectedValue={dealerTSEList}
													onChange={handleContentDealerOptionListChoose}
													disabled={disabledBlock} />
												{/* {isTSEListValidationError && (
													<div className="error-message">{isTSEListValidationError}</div>
												)} */}
											</Col>

											{!userExists && <Col xs={12} lg={4}>
												<SelectDropDown labelName="Marital Status"
													requiredStar="*"
													options={isMaritalList}
													setSelectedValue={setMaritalStatus}
													selectedValue={maritalStatus}
													onChange={handleMaritalStatusOptionChoose}
													disabled={disabledBlock} />
												{/* {isMaritalStatusValidationError &&
													(
														<div className="error-message">{isMaritalStatusValidationError}</div>
													)} */}
											</Col>}
											{maritalStatus.id === 'Married' && (
												<>
													<Col xs={12} lg={4}>
														<InputField
															inputFieldLabel="Spouse Name"
															requiredStar="*"
															name="spouse"
															value={address.spouse}
															onChange={handleBasicRegistrationInput}

														/>
														{/* {isSpouseValidationError && (
															<div className="error-message">{isSpouseValidationError}</div>
														)} */}
													</Col>
													<Row>
													<Col xs={12} lg={4}>
														<DatePicker
															inputFieldLabel="Spouse Date of Birth"
															requiredStar="*"
															name="spouseDOB"
															dobSelection
															value={spouseDob}
															onChange={setSpouseDob}

														/>
														{/* {isSpouseDOBValidationError && (
															<div className="error-message">{isSpouseDOBValidationError}</div>
														)} */}
													</Col>
													<Col xs={12} lg={4}>
														<DatePicker
															inputFieldLabel="Date of Anniversary"
															requiredStar="*"
															name="anniversaryDOB"
															value={anniversary}
															onChange={setAnniversary}

														/>
														{/* {isSpouseValidationAnniError && (
															<div className="error-message">{isSpouseValidationAnniError}</div>
														)} */}
													</Col>
													</Row>
												</>
											)}
											{/* <Col xs={12} lg={3}>

												<PrimaryGradientButton
													buttonText={isButtonLoading ? "Processing..." : "Submit"}
													className={maritalStatus.id === 'Married' ? "mt-4" : "mt-28"}
													onClick={handleBasicRegistrationTSE}
													disabled={isButtonLoading} />

											</Col> */}
											</Row>

											<Col xs={12}>
												<div className="my-3 checkTxt">
													<input
														type="checkbox"
														className="checkTxtBox"
														checked={isChecked}
														onChange={handleCheckboxChange}
													/>
													<span className="mx-2">
														The information provided above are true to my knowledge & I hereby solemnly submit all the documents required. All details captured will be solely used for the purpose of CRMS & Loyalty program only.
													</span>
													{/* {checkBoxValidationAlert && (
														<div className="error-message">
															{checkBoxValidationAlert}
														</div>
													)} */}
												</div>
											</Col>
											<Col xs={12}>
												<div className="my-3 checkTxt">
													<input
														type="checkbox"
														className="checkTxtBox"
														checked={isAgreedChecked}
														onChange={handleAgreeCheckboxChange}
													/>
													<span className="mx-2">
														I have read & agreed to the terms of service & privacy policy
													</span>
													{/* {agreedCheckBoxValidationAlert && (
														<div className="error-message">
															{agreedCheckBoxValidationAlert}
														</div>
													)} */}
												</div>
											</Col>
											<Col xs={12} lg={3}>
												<PrimaryGradientButton
													buttonText={isButtonLoading ? "Processing..." : "Submit"}
													onClick={submitHandler} //handleRegister
													disabled={isButtonLoading}
													loading={isButtonLoading}
												/>
											</Col>
										</Row>
									</div>
								</div>
							</Col>
						</Row>
					</Container>
				</section>
			}

			{/* {basicRegistrationDealerBlockShow &&
				<section className='padTop50'>
					<Container>
						<Row className='justify-content-center align-item-center h-100'>
							<Col xs={12} >
								<div className='userInfoBox'>
									<div className='dashboard-title'>
										<h4>Basic Registration</h4>
									</div>
									<div className="dashboard-details">
										<Row>
											<Col xs={12} lg={3}>
												<DatePicker
													inputFieldLabel="DOB"
													requiredStar="*"
													name="dob"
													value={address.dob}
													onChange={handleBasicRegistrationInput}
													dobSelection

												/>
												{isDOBValidationError && (
													<div className="error-message">{isDOBValidationError}</div>
												)}
											</Col>

											<Col xs={12} lg={3}>
												<SelectDropDown
													page='searchFilter'
													labelName='State'
													requiredStar="*"
													options={isStateList}
													selectedValue={contentState}
													setSelectedValue={setContentState}
													onChange={handleContentStateNameChange} />

												{isStateValidationError && (
													<div className="error-message">{isStateValidationError}</div>
												)}

											</Col>
											<Col xs={12} lg={3}>
												<SelectDropDown
													page='searchFilter'
													labelName='District'
													requiredStar="*"
													options={isDistrictList}
													selectedValue={contentDistrict}
													setSelectedValue={setContentDistrict}
													onChange={handleContentDistrictNameChange} />
												
											</Col>

											<Col xs={12} lg={3}>
												<SelectDropDown labelName="Taluka"
													requiredStar="*"
													options={isTalukaList}
													setSelectedValue={setContentTaluka}
													selectedValue={contentTaluka}
													onChange={handleContentTalukaNameChange} />
												
											</Col>

											<Col xs={12} lg={3}>
												<SelectDropDown labelName={selectedTitle === 'TSE' ? 'Dealer' : 'TSE'}
													requiredStar="*"
													options={dealerOrTseList}
													setSelectedValue={setDealerTSEList}
													selectedValue={dealerTSEList}
													onChange={handleContentDealerOptionListChoose} />
												
											</Col>

											<Col xs={12} lg={3}>
												<InputField
													inputFieldLabel="Address Line"
													requiredStar="*"
													name="line"
													value={address.line}
													onChange={handleBasicRegistrationInput}
												/>
											
											</Col>

											<Col xs={12} lg={3}>
												<SelectDropDown labelName="Marital Status"
													requiredStar="*"
													options={isMaritalList}
													setSelectedValue={setMaritalStatus}
													selectedValue={maritalStatus}
													onChange={handleMaritalStatusOptionChoose} />
												
											</Col>
											{maritalStatus.id === 'Married' && (
												<>
													<Col xs={12} lg={3}>
														<InputField
															inputFieldLabel="Spouse Name"
															requiredStar="*"
															name="spouse"
															value={address.spouse}
															onChange={handleBasicRegistrationInput}

														/>
													
													</Col>
													<Col xs={12} lg={3}>
														<DatePicker
															inputFieldLabel="Spouse Date of Birth"
															requiredStar="*"
															name="spouseDOB"
															dobSelection
															value={address.spouseDOB}
															onChange={handleBasicRegistrationInput}

														/>
														
													</Col>
													<Col xs={12} lg={3}>
														<DatePicker
															inputFieldLabel="Date of Anniversary"
															requiredStar="*"
															name="anniversaryDOB"
															value={address.anniversaryDOB}
															onChange={handleBasicRegistrationInput}

														/>
														
													</Col>
												</>
											)}
											<Col xs={12} lg={3}>

												<PrimaryGradientButton
													buttonText={isButtonLoading ? "Processing..." : "Submit"}
													className={maritalStatus.id === 'Married' ? "mt-4" : "mt-28"}
													onClick={handleBasicRegistrationTSE}
													disabled={isButtonLoading} />

											</Col>
											
										</Row>
									</div>
								</div>
							</Col>
						</Row>
					</Container>
				</section>
			} */}
		</>
	);
};

export default EnrollMember;
